import { get } from "lodash"
import { reducerName } from '../organisations_v1/index'


// Retrieves the first organisation state from the Redux store.
export const selectOrganisations = state => get(state, `${reducerName}.organisationsV1`);
export const selectFirstOrganisation = state => get(state, `${reducerName}.firstOrganisation`);
export const selectHasFetched = state => get(state, `${reducerName}.hasFetched`)
export const selectIsLoading = state => get(state, `${reducerName}.isLoading`)
export const selectLoadingError = state => get(state, `${reducerName}.loadingError`)